// client/components/ShelfRow.tsx
import { Item, api } from '../lib/api';
import { Play } from 'lucide-react';

interface Props {
    title: string;
    libraryItem: Item;
    items: Item[];
    onNavigate: (item: Item) => void;
    square?: boolean;
}

export function ShelfRow({ title, libraryItem, items, onNavigate, square = false }: Props) {
    if (items.length === 0) return null;

    return (
        <div className="mb-8">
            {/* Section header */}
            <button
                onClick={() => onNavigate(libraryItem)}
                className="flex items-center gap-2 mb-3 group"
            >
                <h2 className="text-base font-semibold text-gray-100 group-hover:text-white transition-colors">
                    {title}
                </h2>
                <span className="text-primary text-sm opacity-0 group-hover:opacity-100 transition-opacity">›</span>
            </button>

            {/* Horizontal scroll shelf */}
            <div className="flex gap-3 overflow-x-auto pb-2">
                {items.map((item) => (
                    <div
                        key={item.Id}
                        className="flex-shrink-0 w-[150px] cursor-pointer group/card"
                        onClick={() => onNavigate(item)}
                    >
                        <div className={`relative rounded-md overflow-hidden bg-surface ${square ? 'aspect-square' : 'aspect-[2/3]'}`}>
                            {item.ImageTags?.Primary ? (
                                <img
                                    src={api.getImageUrl(item.Id)}
                                    alt={item.Name}
                                    loading="lazy"
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <div className="w-full h-full flex items-center justify-center bg-gray-800 text-gray-600 text-xs">
                                    No Image
                                </div>
                            )}
                            {/* Hover overlay */}
                            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover/card:opacity-100 transition-opacity flex items-center justify-center">
                                <Play className="w-8 h-8 text-white fill-white" />
                            </div>
                        </div>
                        <p className="mt-1.5 text-xs text-gray-400 truncate px-0.5" title={item.Name}>
                            {item.Name}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
